module.exports = __webpack_public_path__ + "media/application/images/2018/star-green@4x-ef9781f05cf8ca18b118d1e7f4be3f4a.png";